export default __webpack_public_path__ + "static/media/vision.ac8e3e28.svg";